import React, { FC } from 'react'

import SadFaceIcon from '@Assets/SVG/SadFace'
import WarningIcon from '@Assets/SVG/Warning'
import { SVGIcon } from '@Components/Icons'
import { ContentProps } from '@Components/Modal/Dialog'

import styles from './ErrorContent.module.scss'

export const ErrorContent: FC<ContentProps> = ({
  children,
  title,
  variant,
}) => (
  <div className={styles.errorContent}>
    <div className={styles.iconWrapper}>
      <SVGIcon color={variant === 'sadError' ? 'greyDark' : 'primary'} icon={variant === 'sadError' ? SadFaceIcon : WarningIcon} size="60px" />
    </div>
    {title && <div className={styles.title}>{title}</div>}
    <div className={styles.text}>{children}</div>
  </div>
)
